import * as React from 'react'
import { BPMChart } from '../../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../../api'
import { GroupByType } from '../../../../components/GroupByType'

export const CuratorChart: React.FunctionComponent = ({ }) => {
    const [groupBy, setGroupBy] = React.useState<string | undefined>('downloads')
    const toolbarItems = GroupByType([{ val: 'downloads', display: 'Downloads' }, { val: 'streams', display: 'Streams' }], groupBy, (selected) => {
        setGroupBy(selected)
    }, false)
    return (
        <BPMChart title='Curators' subTitle={'By ' + (groupBy == 'downloads' ? 'Downloads' : 'Streams')} type='pie'
            key={groupBy}
            onRequestLoad={(options, signal) => {
                return BPMAnalyticsAPI.get<any>(`curated/${groupBy}/byGroup`, options, signal)
            }} additionalParams={{ groupBy: 'curator' }} toolBarItems={() => toolbarItems}
            allowedTypes={['spline', 'bar', 'doughnut', 'pie', 'tree']}
            series={{
                name: groupBy == 'downloads' ? 'Downloads' : 'Streams', valueField: 'count', argumentField: 'curator',
                smallValuesGrouping: { topCount: 10, mode: 'topN' }
            }}>
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Curated/charts/CuratorChart.tsx